'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

var _pureGraph = require('pure-graph');

var _constants = require('../StaticProjectView/constants');

var _measureText2 = require('components/Projects/utils/measureText');

var _measureText3 = _interopRequireDefault(_measureText2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getNodesRects = function getNodesRects(project) {
  var graph = project.graph;
  var nodesData = project.nodesData;


  var nodes = (0, _pureGraph.getNodes)(graph);
  var mappedNodesData = nodes.map(function (id) {
    return { id: id, data: nodesData[id] };
  });

  var nodesRects = mappedNodesData.map(function (node) {
    var caption = node.data.caption;

    var _measureText = (0, _measureText3.default)({ text: caption, maxWidth: _constants.NODE_MAX_WIDTH });

    var width = _measureText.width;
    var height = _measureText.height;


    return _extends({}, node, {
      width: Math.round(width) + 2 * _constants.NODE_PADDING_HORIZONTAL,
      height: Math.round(height) + 2 * _constants.NODE_PADDING_VERTICAL
    });
  }).reduce(function (res, node) {
    return _extends({}, res, _defineProperty({}, node.id, { width: node.width, height: node.height }));
  }, {});

  return nodesRects;
};

exports.default = getNodesRects;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/utils/getNodesRects.js
// module id = 225
// module chunks = 1